import { Badge } from '@components/ui/badge';
import { cn } from '@lib/utils';
import { getCountryBadgeModel } from '@utils/country-badge.util';
import React from 'react';

type CountryBadgeProps = {
  className?: string;
  jurisdiction: string;
};

export const CountryBadge: React.FC<CountryBadgeProps> = (props) => {
  const { className, jurisdiction } = props;
  const badge = getCountryBadgeModel(jurisdiction);

  return (
    <Badge
      className={cn(badge.className, className)}
      size="xs"
      variant={badge.variant}
    >
      <span aria-hidden="true">{badge.flag}</span>
      {badge.label}
    </Badge>
  );
};
